// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__X9TME","footer":"ModalFilter_footer__3kwQB"};